import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';

import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { AuthSandbox } from '../../../core/auth/auth.sandbox';
import { CommonSandbox } from '../../../core/common/common.sandbox';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../../core/common/common.service';
import { ActivatedRoute } from '@angular/router';
import { ICreateOrderRequest, NgxPaypalComponent, PayPalScriptService } from 'ngx-paypal';
import { PaymentService } from '../../../core/payment/payment.service';
import { Router } from '@angular/router';
import moment from 'moment-timezone';

@Component({
	selector: 'app-vendor-payment',
	templateUrl: './vendor-payment.component.html',
	styleUrls: ['./vendor-payment.component.scss']
})
export class VendorPaymentComponent implements OnInit {
	public showPay = true;
	public payPalConfig: any;
	public paymentisterForm: FormGroup;
	public submitted = false;
	public countries = [];
	public services = null;
	public loading = false;
	public activeService = 0;
	public serviceTitle = '';
	public serviceAmount = 0;
	public serviceId = 0;
	public vendorId = 0;
	public paymentType = 0;
	@ViewChild('payPalElem1') paypalComponent1?: NgxPaypalComponent;

	constructor(public formBuilder: FormBuilder, public authSandbox: AuthSandbox, public commonSandbox: CommonSandbox,
		private toastr: ToastrService,
		private commonService: CommonService,
		private route: ActivatedRoute,
		public paymentService: PaymentService,
		public payPalScriptService: PayPalScriptService,
		private router: Router
	) { }

	ngOnInit() {
		this.route.queryParams.subscribe(data => {
			console.log('dta od aprmas', data);
			this.serviceId = data.id;
			this.paymentType = data.type;
			this.vendorId = data.uid;
			console.log('id of servcie', this.serviceId);
			this.getactiveServices();
		});




		// this.payPalScriptService.registerPayPalScript(this.payPalConfig, (payPalApi) => {
		// 	if (this.paypalComponent1) {
		// 		this.paypalComponent1.customInit(payPalApi);
		// 	}
		// });

	}

	getactiveServices() {
		const params: any = {};

		params.serviceId = this.serviceId

		this.commonService.getactiveServices(params).toPromise().then(response => {
			console.log("response of detail");
			this.services = response.data;

			console.log(this.services);

			console.log(moment.utc().format('YYYY-MM-DD'));

			const subscriptionStartDate = moment.utc().add(response.data.trialPeriod, 'days').format('YYYY-MM-DD') + 'T00:00:00Z';
			console.log("subscriptionStartDate");
			console.log(subscriptionStartDate);

			//const serviceSatrtDate = moment().add(service.trialPeriod, 'days').format('YYYY-m-d')+'T00:00:00Z';

			this.serviceTitle = response.data.title;
			this.serviceAmount = response.data.price;

			if (response.data.trialPeriod == 0) {
				this.payPalConfig = {
					currency: 'USD',
					clientId: response.data.client_id,
					createSubscription: function (data, actions) {
						console.log(" *** response.data.planId", response.data.planId);
						return actions.subscription.create({
							//"plan_id": "P-8YX15033W9521840KMK4U6VY" // Creates the subscription
							plan_id: response.data.planId, // "P-8YX15033W9521840KMK4U6VY"
						},
						);
					},
					vault: 'true',
					advanced: {
						commit: false,
						extraQueryParams: [{ name: 'intent', value: 'subscription' }],
					},


					onApprove: (data, actions) => {
						console.log("Subscription data", data);
						data.serviceId = this.serviceId;
						data.serviceName = this.serviceTitle;
						data.price = this.serviceAmount;
						data.vendorId = this.vendorId;
						this.loading = true;

						if (this.paymentType == 0) {
							this.commonService.saveVendorPayment(data).toPromise().then(response => {
								this.loading = false;
								this.toastr.success('Thank you for signing up with premierstreets.com, your account is up and running, happy stay.', 'Success');
								this.router.navigate(['auth/login']);
							});
						} else {
							this.commonService.updateVendorPayment(data).toPromise().then(response => {
								this.loading = false;
								this.toastr.success('You plan updated successfully');
								this.router.navigate(['dashboard']);
							});
						}
					},

					// onClientAuthorization: (data) => {
					// 	this.toastr.success('Credentials verified successfully', 'Success');
					// },
					onCancel: (data, actions) => {
					},
					onError: err => {
						console.log('OnError', err);
					},
				}
			} else {
				this.payPalConfig = {
					currency: 'USD',
					clientId: response.data.client_id,
					createSubscription: function (data, actions) {
						console.log(" *** response.data.planId", response.data.planId);
						return actions.subscription.create({
							//"plan_id": "P-8YX15033W9521840KMK4U6VY" // Creates the subscription
							plan_id: response.data.planId, // "P-8YX15033W9521840KMK4U6VY"
							start_time: subscriptionStartDate
						},
						);
					},
					vault: 'true',
					advanced: {
						commit: false,
						extraQueryParams: [{ name: 'intent', value: 'subscription' }],
					},


					onApprove: (data, actions) => {
						console.log("Subscription data", data);
						data.serviceId = this.serviceId;
						data.serviceName = this.serviceTitle;
						data.price = this.serviceAmount;
						data.vendorId = this.vendorId;
						this.loading = true;

						if (this.paymentType == 0) {
							this.commonService.saveVendorPayment(data).toPromise().then(response => {
								this.loading = false;
								this.toastr.success('Thank you for signing up with premierstreets.com, your account is up and running, happy stay.', 'Success');
								this.router.navigate(['auth/login']);
							});
						} else {
							this.commonService.updateVendorPayment(data).toPromise().then(response => {
								this.loading = false;
								this.toastr.success('You plan updated successfully');
								this.router.navigate(['dashboard']);
							});
						}
					},
					onCancel: (data, actions) => {
					},
					onError: err => {
						console.log('OnError', err);
					},
				}
			}
			console.log(response);
		});
	}

	public changeCountry(e) {
		console.log(" *****  e.target.value", e);
	}

	public changeCategory(e) {
		console.log(" *****  e.target.value", e);
	}
}
